import api from '../api/axios';
import { VideoRenderSettingsEntity } from '../types/entities';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export const getByRunId = async (runId: string) => {
  const res = await api.get(withBase(`/video-render-settings/by-run/${runId}`));
  return (res.data || null) as VideoRenderSettingsEntity | null;
};

export const upsertByRunId = async (runId: string, body: Partial<VideoRenderSettingsEntity>) => {
  const res = await api.post(withBase(`/video-render-settings/upsert-by-run/${runId}`), body);
  return res.data as VideoRenderSettingsEntity;
};

const renderSettingsService = { getByRunId, upsertByRunId };
export default renderSettingsService;
